import React from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { IFormGridProps } from '../../library/types/IFormGridProps'
import { CheckCrossCell, SystemGrid } from '../../library'
import { SystemActionCell } from '../../library/grid/SystemActionCell';
import { hasDeletePermission } from '../../service/userService';

const CenteredHeaderCell = (props) => {
    return (
        <span className={'TextCenter'}>
            {props.title}
        </span>
    );
};
const OpportunityTypeOptionsGrid = (props: IFormGridProps) => {
    const url = "LookupValue/LookupValuesGet/OpportunityType";

    const [counter, setCount] = React.useState(1500);

    const RefreshGrid = () => {
        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    return <SystemGrid onRowClick={props.onRowClick} pageable={true} dataSource={url} refresh={props.refresh + counter} >
        <Column key={1} field="DataText" title="Lookup Name" width="auto" />
        <Column key={2} field="DataValue" title="Lookup Value" width="auto" />
        <Column key={3} field="Ordinal" title="Order" width="auto" />
        <Column key={4} field="Active" title="Active" width="auto" cell={CheckCrossCell} headerCell={CenteredHeaderCell} />
        <Column key={5} field="" title="Action" width="100" cell={(props) => <SystemActionCell {...props} onDeleteSuccess={RefreshGrid} showDelete={hasDeletePermission('Top.Lookup.OpportunityType')} showAudit={false} schema="Lookup" table="LookupValue" deleteUrl='/LookupValue' />} columnMenu={null} headerCell={CenteredHeaderCell} />
    </SystemGrid>
}
export default OpportunityTypeOptionsGrid